<template>
  <div>
    <a-table size="small" :dataSource="table_data" :columns="columns" rowKey="id"
      :pagination="{ showSizeChanger: true, pageSizeOptions: ['10', '100'] }">
      <div slot="text_filter" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
        style="padding: 8px">
        <a-input v-ant-ref="(c) => (item_search_input = c)" :placeholder="`Search ${column.dataIndex}`"
          :value="selectedKeys[0]" @change="(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => confirm()" style="width: 188px; margin-bottom: 8px; display: block" />
        <a-button type="primary" @click="() => confirm()" icon="search" size="small"
          style="width: 90px; margin-right: 8px">Search</a-button>
        <a-button @click="() => clearFilters()" size="small" style="width: 90px">Reset</a-button>
      </div>
      <div slot="date_filter" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters }"
        style="padding: 8px">
        <a-range-picker size="small" style="width: 200px; margin-bottom: 8px; display: block"
          v-ant-ref="(c) => (date_range_input = c)" v-model="search_date_range"
          @change="setSelectedKeys(search_date_range)" />
        <a-button @click="confirm" type="primary" icon="search" size="small"
          style="width: 90px; margin-right: 8px">Search</a-button>

        <a-button @click="clearFilters" size="small" style="width: 90px; margin-left: 8px">Reset</a-button>
      </div>
      <template slot="creator" slot-scope="text">
        {{text ? users.filter((u) => u.id == text)[0].account : "N/A"}}
      </template>

      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations" style="text-align: center">
          <a-upload name="file" @change="(info) => change_upload(record, info)" :showUploadList="false"
            :fileList="record.attachments" :action="$store.state.base_url + '/upload'" :headers="headers">
            <a-button type="link">Upload Bank Slip</a-button>
          </a-upload>

          <a-popconfirm title="Are you sure Reset to Unpaid?" @confirm="reset_paid(record.id)" okText="Yes"
            cancelText="No">
            <a href="#">Reset to Unpaid</a>
          </a-popconfirm>
        </div>
      </template>

      <template slot="upload" slot-scope="text, record">
        <a class="file_download" v-for="r in record.attachments" :key="r.uid" :href="r.url">{{ r.filename }}</a>
      </template>

      <template slot="amount" slot-scope="text">
        {{ formatUSD(text) }}
      </template>

      <template slot="paid" slot-scope="text">
        <div v-if="text == 'Y'">{{ text }}</div>
        <div v-else style="color: red; font-weight: 900">{{ text }}</div>
      </template>
    </a-table>
  </div>
</template>

<script>
import moment from "moment";
import userinfo from "../utils/userinfo.js";
import users_filter from "./users_filter.js";
import { formatUSD } from "../utils/format_currency.js";

export default {
  name: "payout",
  data() {
    // ES7 deep copy syntax ... will interate and deep copy an object's prop or element of array
    this.cacheData = [];
    return {
      headers: {
        access_token: userinfo.get().access_token,
      },

      userinfo: userinfo.get(),
      users: [],

      table_data: [],
      columns: [
        {
          title: "ID#",
          dataIndex: "id",
          key: "id",
          sortOrder: "descend",
          sorter: (a, b) => a.id - b.id,
        },
        {
          title: "Vessel_Ref",
          dataIndex: "vessel_ref",
          key: "vessel_ref",
        },
        {
          title: "Vessel_Name",
          dataIndex: "vessel_name",
          key: "vessel_name",
          onFilter: (value, record) =>
            record.vessel_ref.toLowerCase().includes(value.toLowerCase()),
          filters: [],
        },
        {
          title: "Creator",
          dataIndex: "creator",
          scopedSlots: { customRender: "creator" },
          onFilter: (value, record) => {
            if (record.creator) {
              return record.creator == value;
            } else {
              return false;
            }
          },
          filters: users_filter,
        },
        {
          title: "Date",
          dataIndex: "date",
          key: "date",
          scopedSlots: {
            filterDropdown: "date_filter",
          },
          onFilter: (value, record) => {
            var date = moment(record.date).set({
              hour: 12,
              minute: 0,
              second: 0,
            });
            var start = this.search_date_range[0].set({
              hour: 0,
              minute: 0,
              second: 0,
            });
            var end = this.search_date_range[1].set({
              hour: 0,
              minute: 0,
              second: 0,
            });
            if (date.isBetween(start, end, "day", "[]")) {
              return true;
            } else {
              return false;
            }
          },
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.date_range_input.focus();
              }, 0);
            }
          },
        },
        {
          title: "Items",
          dataIndex: "items",
          key: "items",
          scopedSlots: {
            filterDropdown: "text_filter",
          },
          onFilter: (value, record) =>
            record.items.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.item_search_input.focus();
              }, 0);
            }
          },
        },
        {
          title: "Beneficiary",
          dataIndex: "beneficiary",
          key: "beneficiary",
          scopedSlots: {
            filterDropdown: "text_filter",
          },
          onFilter: (value, record) =>
            record.beneficiary.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.item_search_input.focus();
              }, 0);
            }
          },
        },
        {
          title: "Amount",
          dataIndex: "amount",
          key: "amount",
          scopedSlots: {
            filterDropdown: "text_filter",
            customRender: "amount",
          },
          sorter: (a, b) => a.id - b.id,
          onFilter: (value, record) =>
            record.amount.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.item_search_input.focus();
              }, 0);
            }
          },
        },
        {
          title: "Remarks",
          dataIndex: "remarks",
          key: "remarks",
          scopedSlots: {
            filterDropdown: "text_filter",
          },
          onFilter: (value, record) =>
            record.remarks.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.item_search_input.focus();
              }, 0);
            }
          },
        },
        {
          title: "Paid?",
          dataIndex: "paid",
          key: "paid",
          scopedSlots: { customRender: "paid" },
          onFilter: (value, record) => {
            if (record.editable) {
              return true;
            }
            return record.paid.toLowerCase().includes(value.toLowerCase());
          },
          filters: [
            { text: "Yes", value: "Y" },
            { text: "No", value: "N" },
          ],
        },
        {
          title: "Upload",
          dataIndex: "upload",
          scopedSlots: { customRender: "upload" },
        },
        {
          title: "operation",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
        },
      ],

      // filter controls and data holder
      item_search_input: null,
      search_date_range: [],
      date_range_input: null,
    };
  },
  methods: {
    formatUSD,
    refresh() {
      var params = {};
      var vid = this.$route.params.vid;
      if (vid == "all") {
        params = {};
      } else {
        params.vessel_id = vid;
      }

      this.shipIDs = [];
      this.$http.post(this.$store.state.base_url + "/payout/r", params).then((res) => {
        if (res.data.status == 1) {
          var data = res.data.data;
          data.forEach((d) => {
            d.vessel_ref = "MV" + (d.vessel_id + 10000 + "").substr(1, 4);
            d.date_obj = moment(d.date);
            d.paid = d.paid ? "Y" : "N";
            d.audited = d.audited ? "Y" : "N";
            d.final_audited = d.final_audited ? "Y" : "N";
          });
          // set cacheData and table_data
          this.cacheData = data.map((item) => ({ ...item }));
          this.table_data = data;
        }
      });
    },

    change_upload(record, info) {
      // console.log('status:', info.file.status)
      if (info.file.status === "done") {
        for (var i = 0; i < info.fileList.length; i++) {
          if (
            info.fileList[i].hasOwnProperty("percent") &
            (info.fileList[i].percent == 100)
          ) {
            var tmp = {};
            tmp.name = info.fileList[i].name;
            tmp.filename = info.fileList[i].name;
            tmp.uid = info.fileList[i].response.data[0].path;
            tmp.path = info.fileList[i].response.data[0].path;
            tmp.url = this.$store.state.site_url + info.file.response.data[0].path;
            tmp.status = "done";
            info.fileList[i] = tmp;
          }
        }
        record.attachments = info.fileList;
        record.paid = "Y";
        var r = JSON.parse(JSON.stringify(record));
        r.paid = true;

        this.$http.post(this.$store.state.base_url + "/payout/u", r).then((res) => {
          if (res.data.status == 1) {
            this.$message.info("Upload Attachment Success");
            this.$forceUpdate();
          }
        });
        return;
      }
      if (info.file.status === "removed") {
        console.log("removed");
        record.attachments = info.fileList;
        r = JSON.parse(JSON.stringify(record));
        r.paid = r.paid == "Y" ? true : false;

        this.$http.post(this.$store.state.base_url + "/payout/u", r).then((res) => {
          if (res.data.status == 1) {
            this.$message.info("Upload Attachment Success");
          }
        });
      }
      console.log("fileList=>attachments");
      record.attachments = info.fileList;
    },

    reset_paid(id) {
      this.$http
        .post(this.$store.state.base_url + "/payout/u", { id: id, paid: false })
        .then((res) => {
          if (res.data.status == 1) {
            this.refresh();
          }
        });
    },
  },

  mounted() {
    this.refresh();
    this.$http.post(this.$store.state.base_url + "/user/r", {}).then((res) => {
      if (res.data.status == 1) {
        var data = res.data.data;
        this.users = data;
      }
    });
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.refresh();
      },
    },
  },
};
</script>
<style>
.file_download {
  display: block;
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
